import React from 'react';
import { Alert, AlertContent, AlertTitle } from '@heroui/react';
import { RhinoErrorReporterContext } from '@rhino-project/core/lib';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  title?: string | null;
}

interface ErrorBoundaryState {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  static contextType = RhinoErrorReporterContext;
  declare context: React.ContextType<typeof RhinoErrorReporterContext>;

  // eslint-disable-next-line @eslint-react/no-unused-class-component-members
  title: string;

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
    // eslint-disable-next-line @eslint-react/no-unused-class-component-members
    this.title =
      props?.title ||
      'Something went wrong. Please refresh the page to retry or use the menu to start over.';
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    this.context.report(error);
  }

  render() {
    const { errorInfo } = this.state;
    const { children, title } = this.props;

    if (errorInfo) {
      // Error path
      return (
        <div className="pt-3">
          <Alert status="danger">
            <AlertContent>
              <AlertTitle>
                {title ||
                  'Something went wrong. Please refresh the page to retry or use the menu to start over.'}
              </AlertTitle>
            </AlertContent>
          </Alert>
        </div>
      );
    }
    return children;
  }
}
